import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

export type Inputs =
  | "metaVentas"
  | "metaReactivaciones"
  | "metaConsolidada"
  | "observaciones";
export type Buttons = "aceptar" | "cancelar";

const createMetasFormConfig = (
  includeObservaciones: boolean = true
): FormBuilderConfig<Inputs, Buttons> => {
  const inputs: any[] = [
    {
      name: "metaVentas",
      label: "Meta de Ventas",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        type: "NUMERIC"
      }
    },
    {
      name: "metaReactivaciones",
      label: "Meta de Reactivaciones",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        type: "NUMERIC"
      }
    },
    {
      name: "metaConsolidada",
      label: "Meta Consolidada",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        type: "NUMERIC"
      }
    }
  ];

  if (includeObservaciones) {
    inputs.push({
      name: "observaciones",
      label: "Observaciones",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {}
    });
  }

  const validations: any = {
    metaVentas: {
      required: true
    },
    metaReactivaciones: {
      required: true
    },
    metaConsolidada: {
      required: true
    }
  };

  if (includeObservaciones) {
    validations.observaciones = {
      required: true
    };
  }

  const rows: any[] = [
    ["metaVentas"],
    ["metaReactivaciones"],
    ["metaConsolidada"]
  ];

  if (includeObservaciones) {
    rows.push(["observaciones"]);
  }

  rows.push(["aceptar", "cancelar"]);

  return {
    inputs,
    buttons: [
      {
        name: "aceptar",
        label: "Guardar",
        isSubmit: true,
        bts: { mCol: 6 },
        component: IButtonBuilder,
        props: {}
      },
      {
        name: "cancelar",
        label: "Cancelar",
        isSubmit: false,
        bts: { mCol: 6 },
        component: IButtonBuilder,
        props: {}
      }
    ],
    validations,
    rows
  };
};

// Exportar versión por defecto con observaciones para retrocompatibilidad
export const metasPresupuestadasFormConfig: FormBuilderConfig<
  Inputs,
  Buttons
> = createMetasFormConfig(false);
export const metasFormConfig: FormBuilderConfig<
  Inputs,
  Buttons
> = createMetasFormConfig(true);
